import { useEffect, useRef } from 'react';
import { useViewer } from './ViewerContext';

export function ViewerCanvas() {
  const ref = useRef<HTMLCanvasElement | null>(null);
  const { attachCanvas } = useViewer();

  useEffect(() => {
    if (ref.current) attachCanvas(ref.current);
  }, [attachCanvas]);

  return <canvas ref={ref} className="absolute inset-0 h-full w-full outline-none" />;
}
